module.exports = __webpack_public_path__ + "img/honore-fanonne-jeffers.e735ff1d.png";